/** The raw statute and regulation fields both formatters read. */
export type LrrDisplayFields = {
  legislation_name: string
  title: string | null
  slug: string
  citation: string | null
  law_type: string
  jurisdiction_code: string
}

/** Statute or regulation title: the name says what the law is, and the citation is what a lawyer would cite. */
export function formatLrrTitle(fields: LrrDisplayFields): string {
  const name = fields.legislation_name || fields.title || fields.slug
  return fields.citation ? `${name} — ${fields.citation}` : name
}

/** The metadata line shown under a statute or regulation title: law type and jurisdiction, each only when known. */
export function formatLrrMetadataLine(fields: LrrDisplayFields): string | null {
  const parts: string[] = []
  if (fields.law_type) parts.push(capitalize(fields.law_type))
  if (fields.jurisdiction_code) parts.push(fields.jurisdiction_code)

  return parts.length > 0 ? parts.join(' • ') : null
}

function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1)
}
